import { useQuery } from 'react-query'
import { healthCheckApi } from '@/lib/api'

export default function CrisisIndicator() {
  const { data: health } = useQuery('health', healthCheckApi.check, {
    refetchInterval: 60000, // Check every minute
  })

  if (!health?.crisis_mode?.enabled) return null

  return (
    <div className="flex items-center space-x-2 px-3 py-1 bg-crisis-orange bg-opacity-10 rounded-full">
      <div className="h-2 w-2 bg-crisis-orange rounded-full animate-pulse" />
      <span className="text-xs font-medium text-crisis-orange">Crisis Mode Active</span>
      <span className="text-xs text-olive-600">
        {health.crisis_mode.rate_multiplier}x Bandwidth
      </span>
    </div>
  )
}
